// Client-side entitlement hook. Uses the runtime provider (Stripe on web,
// RevenueCat on native) so premium gating is identical across platforms.
import { useEffect, useState } from "react";
import { getEntitlementProvider } from "@/lib/entitlements";
import type { EntitlementStatus } from "@/lib/entitlements";

const FREE: EntitlementStatus = { tier: "free", active: false, source: "none" };

export function useEntitlement(): { status: EntitlementStatus; loading: boolean; isMember: boolean } {
  const [status, setStatus] = useState<EntitlementStatus>(FREE);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const provider = await getEntitlementProvider();
        const next = await provider.getStatus();
        if (!cancelled) setStatus(next);
      } catch {
        if (!cancelled) setStatus(FREE);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return { status, loading, isMember: status.active && status.tier !== "free" };
}
